import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { customerDetail } from '../../redux/Customer/action';
import { estimateData as estimateDetailApi } from '../../redux/Estimate/action';
import { ESTIMATE_STATUS, isIssuedEstimate } from '../../utility/Constant';
import EstimateDraft from './NewEstimates/EstimateDraft';
import EstimateFinalized from './NewEstimates/EstimateFinalized';
import EstimateSent from './NewEstimates/EstimateSent';

const EstimateDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [estimateData, setEstimateData] = useState(null);
    const [customerData, setCustomerData] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const fetchEstimateDetailsApi = useCallback(async () => {
        setShowLoader(true);
        let data = await dispatch(estimateDetailApi(id));
        if (data) {
            setEstimateData(data);
            if (isIssuedEstimate(data?.status) && !data?.isEmailSent) {
                fetchCustomerDetail(data);
            }
        }
        setShowLoader(false);
    }, [dispatch, id]);

    const fetchCustomerDetail = async (data) => {
        setShowLoader(true);

        await dispatch(customerDetail(data?.customer?._id));
        setShowLoader(false);
    };

    useEffect(() => {
        fetchEstimateDetailsApi();
    }, [fetchEstimateDetailsApi]);

    // Fetch estimated details and navigate based on status
    // useEffect(() => {
    //     if (!estimateData || !id) return;
    //     const { status, isEmailSent } = estimateData;
    //     const locationPath = location.pathname;
    //     let targetPath = '';

    //     if (status === 'draft') {
    //         targetPath = `/estimates/draft/${id}`;
    //     } else if (status === 'sent' && !isEmailSent) {
    //         targetPath = `/estimates/finalized/${id}`;
    //     } else if (status === 'sent' && isEmailSent) {
    //         targetPath = `/estimates/sent/${id}`;
    //     }

    //     if (targetPath && locationPath !== targetPath) {
    //         navigate(targetPath);
    //     }
    // }, [estimateData, id, navigate, location.pathname]);

    // Work order / invoiced estimates are sent estimates that were converted: emailed or not still
    // decides between the Sent and the Finalized page.
    const isIssued = isIssuedEstimate(estimateData?.status);

    switch (true) {
        case estimateData?.status === ESTIMATE_STATUS.DRAFT:
            return <EstimateDraft estimateId={id} estimateData={estimateData} showLoader={showLoader} setShowLoader={setShowLoader} />;
        case isIssued && estimateData?.isEmailSent:
            return (
                <EstimateSent
                    estimateId={id}
                    estimateData={estimateData}
                    showLoader={showLoader}
                    setShowLoader={setShowLoader}
                    fetchApi={fetchEstimateDetailsApi}
                />
            );
        case isIssued && !estimateData?.isEmailSent:
            return (
                <EstimateFinalized
                    estimateId={id}
                    estimateData={estimateData}
                    customerData={customerData}
                    setCustomerData={setCustomerData}
                    showLoader={showLoader}
                    setShowLoader={setShowLoader}
                    fetchApi={fetchEstimateDetailsApi}
                />
            );
        case showLoader === true:
            return (
                <Dialog open={showLoader}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            );
        default:
            return null;
    }
};

export default EstimateDetail;
